import { render, staticRenderFns } from "./BiometricShimmer.vue?vue&type=template&id=212fcc9a&scoped=true&"
import script from "./BiometricShimmer.vue?vue&type=script&lang=js&"
export * from "./BiometricShimmer.vue?vue&type=script&lang=js&"
import style0 from "./BiometricShimmer.vue?vue&type=style&index=0&id=212fcc9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212fcc9a",
  null
  
)

export default component.exports